import { createApiInstance } from "./api";

const dashboardApiInstance = createApiInstance("/dashboard");

export const dashboardApi = {
  // Admin homepage — single request (admin-only server-side)
  getAdminStats: async () => {
    const response = await dashboardApiInstance.get("/admin-stats");
    return response.data;
  },

  // Super admin homepage — single request
  getSuperAdminStats: async () => {
    const response = await dashboardApiInstance.get("/super-admin-stats");
    return response.data;
  },
};
